import { render } from "./ManagerGroupsRolView.vue?vue&type=template&id=ee8ccbf8"
import script from "./ManagerGroupsRolView.vue?vue&type=script&lang=js"
export * from "./ManagerGroupsRolView.vue?vue&type=script&lang=js"

import "./ManagerGroupsRolView.vue?vue&type=style&index=0&id=ee8ccbf8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__